export default function PropertyList() {
  return <div>hello word </div>;
}
